import React from 'react'
import {
  TextField,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableFooter,
  Chip
} from '@material-ui/core'
import { months, quarters, biannuals, annuals } from '../../../../../../../../assets/js/variables'
import { KeyboardDatePicker } from '@material-ui/pickers'
import moment, { isMoment } from 'moment'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import icons from '../../../../../../../../icons'

const monthDetailPanelColumns = months.reduce(
  (transformed, month) => {
    return {
      ...transformed,
      [month.value]: {
        label: month.stringVar
      }
    }
  },
  { 0: { label: '' } }
)

const quarterDetailPanelColumns = quarters.reduce(
  (transformed, q) => {
    return {
      ...transformed,
      [q.value]: {
        label: q.stringVar
      }
    }
  },
  { 0: { label: '' } }
)

const biannualDetailPanelColumns = biannuals.reduce(
  (transformed, bi) => {
    return {
      ...transformed,
      [bi.value]: {
        label: bi.stringVar
      }
    }
  },
  { 0: { label: '' } }
)

const yearDetailPanelColumns = annuals.reduce(
  (transformed, annual) => {
    return {
      ...transformed,
      [annual.value]: {
        label: annual.stringVar
      }
    }
  },
  { 0: { label: '' } }
)

export function DetailPanelHeader({
  translate,
  frequencyCode,
  detailList,
  openCommentModal,
  rowChanged
}) {
  let detailPanelColumns = {}
  switch (frequencyCode) {
    case 'FQT01':
      detailPanelColumns = yearDetailPanelColumns
      break
    case 'FQT02':
      detailPanelColumns = biannualDetailPanelColumns
      break
    case 'FQT03':
      detailPanelColumns = quarterDetailPanelColumns
      break
    case 'FQT04':
      detailPanelColumns = monthDetailPanelColumns
      break

    default:
      break
  }

  const columns = Object.entries(detailPanelColumns).map(listItem => {
    let [listItemKey, listItemAttr] = listItem
    const detailRow = detailList.find(detail => +detail.frequency_no === +listItemKey)

    let chip = null
    let naChip = null
    if (detailRow) {
      const isNa = detailRow.is_na
      chip = (
        <Chip
          style={{ marginLeft: 5 }}
          color={'default'}
          label={<FontAwesomeIcon icon={icons.faComment} />}
          size={'small'}
          onClick={() => openCommentModal(detailRow.result_kpi_id)}
        />
      )
      naChip = (
        <Chip
          style={{ marginLeft: 5 }}
          color={isNa ? 'secondary' : 'default'}
          label={'N/A'}
          size={'small'}
          onClick={() => rowChanged({ ...detailRow, is_na: !isNa, actual_value: '' })}
        />
      )
    }

    return (
      <TableCell key={`${listItemKey}DetailHeader`} style={listItemAttr?.style}>
        {translate(listItemAttr?.label || '')}
        {chip}
        {naChip}
      </TableCell>
    )
  })
  return (
    <TableHead>
      <TableRow>{columns}</TableRow>
    </TableHead>
  )
}

export const DetailPanelBody = ({
  detailList,
  rowChanged,
  kpiTypeDate = false,
  translate,
  frequencyCode,
  inputDisabled,
  adopted
}) => {
  let rowName = translate('actualValue')
  let detailPanelColumns = {}
  // const now = moment()
  // const currentMonth = now.month() + 1
  // let multiplier = false
  switch (frequencyCode) {
    case 'FQT01':
      detailPanelColumns = yearDetailPanelColumns
      // multiplier = 12
      break
    case 'FQT02':
      detailPanelColumns = biannualDetailPanelColumns
      // multiplier = 6
      break
    case 'FQT03':
      detailPanelColumns = quarterDetailPanelColumns
      // multiplier = 3
      break
    case 'FQT04':
      detailPanelColumns = monthDetailPanelColumns
      // multiplier = 1
      break

    default:
      break
  }

  // const detailDisplay = Array.from(rowNames, (rowName, index) => {
  const dataColumns = Object.entries(detailPanelColumns).map(column => {
    let [columnKey] = column

    let inputElement = null
    const row = detailList?.find(kpiResult => +kpiResult.frequency_no === +columnKey) || {}
    // const isCurrentPeriod =
    //   (columnKey - 1) * multiplier < currentMonth && currentMonth <= columnKey * multiplier

    // const isPreviousPeriod =
    //   (columnKey - 1) * multiplier < currentMonth - 1 && currentMonth - 1 <= columnKey * multiplier

    let value = row?.actual_value || ''
    const disabled = inputDisabled || !row?.is_input_data || row.is_na
    if (kpiTypeDate) {
      const columnValue = value ? moment(value, 'YYYY-MM-DD') : null

      inputElement = (
        <KeyboardDatePicker
          margin='normal'
          format='YYYY MM DD'
          value={columnValue}
          onChange={date =>
            rowChanged({
              ...row,
              actual_value: isMoment(date) ? date.format('YYYY-MM-DD') : date
            })
          }
          KeyboardButtonProps={{
            'aria-label': 'change date'
          }}
          // disabled={inputDisabled || adopted || !isCurrentPeriod}
          disabled={disabled || adopted}
        />
      )
    } else {
      const columnValue = value

      inputElement = (
        <TextField
          type={'number'}
          value={isNaN(+columnValue) ? '' : columnValue}
          // disabled={inputDisabled || adopted || !isCurrentPeriod}
          disabled={disabled || adopted}
          onChange={e =>
            rowChanged({
              ...row,
              actual_value: e.target.value
            })
          }
          onBlur={() => {
            rowChanged({
              ...row,
              actual_value: isNaN(parseFloat(columnValue)) ? '' : parseFloat(columnValue).toFixed(4)
            })
          }}
        />
      )
    }

    if (columnKey === '0') {
      inputElement = rowName
    }
    return <TableCell key={columnKey}>{inputElement}</TableCell>
  })
  // })
  return (
    <TableBody>
      <TableRow>{dataColumns}</TableRow>
    </TableBody>
  )
}

export const DetailPanelFooter = ({ rowData }) => {
  return (
    <TableFooter>
      <TableRow>
        <TableCell colSpan={3}>{rowData.responsible?.responsible_name}</TableCell>
      </TableRow>
    </TableFooter>
  )
}
